import React from "react";
import { cn } from "../../lib/utils";
import { ShellHeader } from "../header/shell-header";

/**
 * SimpleLayout - A basic layout without side panel
 * Perfect for landing pages, auth forms, or single-purpose pages
 */
export function SimpleLayout({
  children,
  footer,
  headerProps = {},
  className = "",
  contentClassName = "",
  footerClassName = "",
  maxWidth = "max-w-7xl", // Container max width
  centerContent = true,
  showHeader = true,
}) {
  return (
    <div className={cn("min-h-screen flex flex-col bg-page", className)}>
      {/* Shell Header */}
      {showHeader && (
        <ShellHeader
          {...headerProps}
          className={cn(
            "bg-neutral-1 border-b border-neutral-5",
            headerProps.className
          )}
        />
      )}

      {/* Main Content */}
      <main className={cn("flex-1 bg-neutral-1", contentClassName)}>
        <div
          className={cn(
            "w-full px-6 py-8",
            centerContent && "mx-auto",
            maxWidth
          )}
        >
          {children}
        </div>
      </main>

      {/* Footer */}
      {footer && (
        <footer
          className={cn(
            "bg-neutral-3 border-t border-neutral-5",
            footerClassName
          )}
        >
          <div
            className={cn(
              "w-full px-6 py-4",
              centerContent && "mx-auto",
              maxWidth
            )}
          >
            {footer}
          </div>
        </footer>
      )}
    </div>
  );
}

/**
 * CenteredLayout - Layout for forms, auth pages, etc.
 * Centers content both horizontally and vertically
 */
export function CenteredLayout({
  children,
  headerProps = {},
  className = "",
  contentClassName = "",
  maxWidth = "max-w-md",
  showHeader = false,
}) {
  return (
    <div className={cn("min-h-screen flex flex-col bg-page", className)}>
      {/* Optional Header */}
      {showHeader && (
        <ShellHeader
          {...headerProps}
          className={cn(
            "bg-neutral-1 border-b border-neutral-5",
            headerProps.className
          )}
        />
      )}

      {/* Centered Content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div
          className={cn(
            "w-full bg-neutral-1 rounded-xl border border-neutral-5 shadow-sm p-8",
            maxWidth,
            contentClassName
          )}
        >
          {children}
        </div>
      </main>
    </div>
  );
}
